import styled from 'styled-components'
import tw from 'twin.macro'

export const TileWrapper = styled.div<{ isValueSelected: boolean }>`
  ${tw`py-2 px-4 min-h-[68px] bg-cream-dark active:border active:border-tertiary rounded-[20px] hover:border h-full my-2 cursor-pointer flex flex-col justify-center`}
  ${({ isValueSelected }) =>
    isValueSelected
      ? tw`bg-opacity-25 border border-tertiary focus:border focus:border-tertiary active:border active:border-tertiary bg-tertiary shadow-md rounded-[20px] text-black-light`
      : tw`text-silver border border-cream-dark hover:border-tertiary hover:border`}
`
export const TileLabel = styled.span<{ isValueSelected: boolean }>`
  ${tw`font-primary text-base peer-checked:block leading-6 text-left font-semibold`}
  ${({ isValueSelected }) => (isValueSelected ? tw`text-black-light` : tw`text-silver`)}
`
